// External libraries
import gql from 'graphql-tag';

// TODO: GenericAddress fields deprecated in favor of portable addresses
// see: https://github.paypal.com/Checkout-R/xobuyernodeserv/pull/2746
/* eslint graphql/no-deprecated-fields: off */
export const THREE_DS_2_CONTINGENCY_FRAGMENT = gql`
  fragment threeDSContingencyData on PaymentContingencies {
    threeDSContingencyData {
      name
      causeName
      resolution {
        type
        resolutionName
        paymentCard {
          billingAddress {
            line1
            line2
            city
            state
            country
            postalCode
          }
          expireYear
          expireMonth
          currencyCode
          cardProductClass
          id
          encryptedNumber
          type
          number
          bankIdentificationNumber
        }
        contingencyContext {
          deviceDataCollectionUrl {
            href
          }
          jwtSpecification {
            jwtDuration
            jwtIssuer
            jwtOrgUnitId
            type
          }
          reason
          referenceId
          source
        }
      }
    }
  }
`;
